import { default as PlaintextSerializer } from 'slate-plain-serializer';

export default PlaintextSerializer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/text_editor/serializers/plaintext_serializer.jsx